import script from "./OrganizationSummaryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationSummaryModal.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationSummaryModal.vue?vue&type=style&index=0&id=67953f37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67953f37"]])

export default __exports__